export const DEFAULT_MEMBER_CENTER_APPEARANCE = {
    version: 1,
    heading: '會員中心',
    cardCaption: '會員卡',
    supportNote: '點數資料僅供查看；其他服務請洽櫃檯。',
    visibleMetrics: ['rewardPoints', 'prizeCredits'],
};
//# sourceMappingURL=member-portal.js.map